<template>
  <b-row>
    <b-col xl="2" lg="3" md="4" sm="6">
      <b-form-group
        :invalid-feedback="
          invalidFeedbackMedicalSystemNumber
            ? $t(`validation.${invalidFeedbackMedicalSystemNumber}`, {
                field: $t('user.medicalSystemNumber'),
              })
            : ''
        "
        :state="v.medicalSystemNumber.$dirty ? ((!v.medicalSystemNumber.$invalid === false) ? false : null) : null"

        :label="$t('user.medicalSystemNumber')"
        label-for="user-medicalSystemNumber"
        :class="{ 'required-group': !v.medicalSystemNumber.required }"
      >
        <b-form-input
            :state="v.medicalSystemNumber.$dirty ? ((!v.medicalSystemNumber.$invalid === false) ? false : null) : null"
            aria-describedby="user-username-feedback"
          v-model="medicalSystemNumber"
          id="user-medicalSystemNumber"
          dir="ltr"
          type="number"
        />
      </b-form-group>
    </b-col>
    <b-col xl="2" lg="3" md="4" sm="6">
      <b-form-group
        label-for="user-startDateAtWork"
        :label="$t('user.startDateAtWork')"
      >
        <my-ab-date-picker
          :mode="'single'"
          :type="'date'"
          :locale="'fa,en'"
          click-on="all"
          clearable
          :show="false"
          :auto-submit="true"
          :column="1"
          v-model="startDateAtWork"
        >
        </my-ab-date-picker>
      </b-form-group>
    </b-col>
    <b-col xl="2" lg="3" md="4" sm="6">
      <b-form-group
        label-for="user-endDateAtWork"
        :label="$t('user.endDateAtWork')"
      >
        <my-ab-date-picker
          :mode="'single'"
          :type="'date'"
          :locale="'fa,en'"
          click-on="all"
          clearable
          :show="false"
          :auto-submit="true"
          :column="1"
          v-model="endDateAtWork"
          :to="'1499'"
        >
        </my-ab-date-picker>
      </b-form-group>
    </b-col>
    <b-col xl="2" lg="3" md="4" sm="6">
      <b-form-group
        label-for="user-completionDateOfMedicalLicense"
        :label="$t('user.completionDateOfMedicalLicense')"
      >
        <my-ab-date-picker
          :mode="'single'"
          :type="'date'"
          :locale="'fa,en'"
          click-on="all"
          clearable
          :show="false"
          :auto-submit="true"
          :column="1"
          v-model="completionDateOfMedicalLicense"
        >
        </my-ab-date-picker>
      </b-form-group>
    </b-col>
    <b-col xl="2" lg="3" md="4" sm="6">
      <b-form-group
        :invalid-feedback="
          invalidFeedbackSpeciality
            ? $t(`validation.${invalidFeedbackSpeciality}`, {
                field: $t('user.medicalSpecialtyId'),
              })
            : ''
        "
        :state="v.medicalSpecialtyId.$dirty ? ((!v.medicalSpecialtyId.$invalid === false) ? false : null) : null"
        :label="$t('user.medicalSpecialtyId')"
        label-for="user-speciality"
        :class="{ 'required-group': !v.medicalSpecialtyId.required }"
      >
        <my-v-select
          :key="medicalSpecialtyId"
          id="user-speciality"
          v-if="medicalSpecialties"
          :translate="false"
          v-model="medicalSpecialtyId"
          :concat-label="['title']"
          :options="medicalSpecialties.length ? medicalSpecialties : []"
          :multiple="false"
          :searchable="true"
          :filterable="true"
        />
      </b-form-group>
    </b-col>
    <b-col xl="2" lg="3" md="4" sm="6">
      <b-form-group
        :label="$t('user.medicalScientificDegreeId')"
        label-for="user-scientificDegree"
      >
        <my-v-select
          :key="medicalScientificDegreeId"
          id="user-scientificDegree"
          v-if="medicalScientificDegrees"
          :translate="false"
          v-model="medicalScientificDegreeId"
          :concat-label="['title']"
          :options="
            medicalScientificDegrees.length ? medicalScientificDegrees : []
          "
          :multiple="false"
          :searchable="true"
          :filterable="true"
        />
      </b-form-group>
    </b-col>
    <b-col xl="2" lg="3" md="4" sm="6">
      <b-form-group
        :label="$t('user.officeLicenseNumber')"
        label-for="user-officeLicenseNumber"
      >
        <b-form-input
          @keypress="isNumber($event)"
          v-model="officeLicenseNumber"
          id="user-officeLicenseNumber"
          dir="ltr"
          type="number"
        />
      </b-form-group>
    </b-col>
    <b-col xl="3" lg="3" md="4" sm="6">
      <b-form-group
        :label="$t('user.statusOfMembership')"
        label-for="user-status-of-membership"
      >
        <my-v-select
          :key="facultyStatus"
          id="user-status-of-membership"
          v-if="statusOfMemberships"
          :translate="false"
          v-model="facultyStatus"
          :concat-label="['text']"
          :reduce-field="['value']"
          :options="statusOfMemberships.length ? statusOfMemberships : []"
          :multiple="false"
          :searchable="true"
          :filterable="true"
        />
      </b-form-group>
    </b-col>
  </b-row>
</template>
<script>
import onlyEnglish from "@/mixins/onlyEnglish";
import MyAbDatePicker from "@/components/wrapper/datePicker/MyAbDatePicker";
import { mapGetters } from "vuex";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormSelect,
  BFormInvalidFeedback,
  BFormSelectOption,
  BFormRadioGroup,
  BFormText,
} from "bootstrap-vue";
import MyVSelect from "@/components/wrapper/select/MyVSelect";
export default {
  components: {
    MyVSelect,
    MyAbDatePicker,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
    BFormInvalidFeedback,
    BFormSelectOption,
    BFormRadioGroup,
    BFormText,
  },
  props: ["v"],
  mixins: [onlyEnglish],
  computed: {
    ...mapGetters({
      medicalSpecialties: "medicalSpecialties/medicalSpecialties",
      statusOfMemberships: "user/statusOfMemberships",
      medicalScientificDegrees:
        "medicalScientificDegrees/medicalScientificDegrees",
    }),
    medicalSystemNumber: {
      set(medicalSystemNumber) {
        this.$store.commit(
          "user/SET_MEDICAL_SYSTEM_NUMBER",
          medicalSystemNumber
        );
      },
      get() {
        return this.$store.getters["user/medicalSystemNumber"];
      },
    },
    startDateAtWork: {
      set(startDateAtWork) {
        this.$store.commit("user/SET_START_DATE_AT_WORK", startDateAtWork);
      },
      get() {
        return this.$store.getters["user/startDateAtWork"];
      },
    },
    endDateAtWork: {
      set(endDateAtWork) {
        this.$store.commit("user/SET_END_DATE_AT_WORK", endDateAtWork);
      },
      get() {
        return this.$store.getters["user/endDateAtWork"];
      },
    },
    completionDateOfMedicalLicense: {
      set(completionDateOfMedicalLicense) {
        this.$store.commit(
          "user/SET_COMPLETION_DATE_OF_MEDICAL_LICENSE",
          completionDateOfMedicalLicense
        );
      },
      get() {
        return this.$store.getters["user/completionDateOfMedicalLicense"];
      },
    },
    medicalSpecialtyId: {
      set(medicalSpecialtyId) {
        this.$store.commit("user/SET_MEDICAL_SPECIALTY_ID", medicalSpecialtyId);
      },
      get() {
        return this.$store.getters["user/medicalSpecialtyId"];
      },
    },
    medicalScientificDegreeId: {
      set(medicalScientificDegreeId) {
        this.$store.commit(
          "user/SET_MEDICAL_SCIENTIFIC_DEGREE_ID",
          medicalScientificDegreeId
        );
      },
      get() {
        return this.$store.getters["user/medicalScientificDegreeId"];
      },
    },
    officeLicenseNumber: {
      set(officeLicenseNumber) {
        this.$store.commit(
          "user/SET_OFFICE_LICENSE_NUMBER",
          officeLicenseNumber
        );
      },
      get() {
        return this.$store.getters["user/officeLicenseNumber"];
      },
    },
    facultyStatus: {
      set(facultyStatus) {
        this.$store.commit("user/SET_FACULTY_STATUS", facultyStatus);
      },
      get() {
        return this.$store.getters["user/facultyStatus"];
      },
    },
    invalidFeedbackMedicalSystemNumber: {
      set(error) {},
      get() {
        var error = "";
        if (!this.v.medicalSystemNumber.$dirty) return error;
        if (!this.v.medicalSystemNumber.required) error = "required";
        return error;
      },
    },
    // invalidFeedbackStartDateAtWork: {
    //   set(error) {},
    //   get() {
    //     var error = "";
    //     if (!this.v.startDateAtWork.$dirty) return error;
    //     if (!this.v.startDateAtWork.required) error = "required";
    //     return error;
    //   },
    // },
    // invalidFeedbackEndDateAtWork: {
    //   set(error) {},
    //   get() {
    //     var error = "";
    //     if (!this.v.endDateAtWork.$dirty) return error;
    //     if (!this.v.endDateAtWork.required) error = "required";
    //     return error;
    //   },
    // },
    invalidFeedbackSpeciality: {
      set(error) {},
      get() {
        var error = "";
        if (!this.v.medicalSpecialtyId.$dirty) return error;
        if (!this.v.medicalSpecialtyId.required) error = "required";
        return error;
      },
    },
    // invalidFeedbackScientificDegree: {
    //   set(error) {},
    //   get() {
    //     var error = "";
    //     if (!this.v.medicalScientificDegreeId.$dirty) return error;
    //     if (!this.v.medicalScientificDegreeId.required) error = "required";
    //     return error;
    //   },
    // },
    // invalidFeedbackStatusOfMembership: {
    //   set(error) {},
    //   get() {
    //     var error = "";
    //     if (!this.v.facultyStatus.$dirty) return error;
    //     if (!this.v.facultyStatus.required) error = "required";
    //     return error;
    //   },
    // },
  },
};
</script>
